import { Link } from "react-router-dom";

export function AnimalNotFoundPage() {
  return (
    <>
      <title>Animal no encontrado · HATO</title>
      <div className="mt-12 flex flex-col items-center gap-4 text-center">
        <h1 className="font-medium text-[20px] text-app-ink-1">Animal no encontrado</h1>
        <p className="max-w-sm text-app-ink-2 text-sm">
          No existe un animal con ese identificador en esta cuenta, o no tenés acceso.
        </p>
        <Link
          to="/app/hato"
          className="rounded-xl border border-app-border bg-app-surface px-4 py-2 font-medium text-[13px] text-app-ink-1 hover:bg-app-surface-2"
        >
          ← Volver al hato
        </Link>
      </div>
    </>
  );
}
